import React, { useEffect, useState } from 'react';
import insightsPlaceholder from '../assets/images/insights.png';
import '../styles/blogPostImage.css';

function BlogPostImage({ src, alt, className = '' }) {
  const [imageSrc, setImageSrc] = useState(src || insightsPlaceholder);

  useEffect(() => {
    setImageSrc(src || insightsPlaceholder);
  }, [src]);

  const handleError = () => {
    if (imageSrc !== insightsPlaceholder) {
      setImageSrc(insightsPlaceholder);
    }
  };

  const isPlaceholder = imageSrc === insightsPlaceholder;

  return (
    <div className={`blog-post-image-wrap ${className}`.trim()}>
      <img
        src={imageSrc}
        alt={isPlaceholder ? 'QASHQ blog placeholder' : alt}
        loading="lazy"
        decoding="async"
        className={`blog-post-image${isPlaceholder ? ' blog-post-image--placeholder' : ''}`}
        onError={handleError}
      />
    </div>
  );
}

export default BlogPostImage;
